module.exports = __webpack_public_path__ + "4da87545.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/service-credit.svg
// module id = 3088
// module chunks = 17